module.exports = __webpack_public_path__ + "img/boshi.429ebe87.png";